import React from 'react';
import Proformas from './Proformas/Proformas';
import Historial from './Historial';
import Facturacion from './Facturacion/index';
import EquiposLogistica from './EquiposLogistica/index';
import AccesosDirecto from './AccesosDirecto';
import Bonos from './Bonos/Bonos';
import Adjuntos from './Adjuntos';
import Excepciones from './Excepciones';
import Observaciones from './Observaciones';
import ErrorUIComponent from '../../../utils/ErrorUIComponent';

function renderTabcontainer(id, that) {


  switch (that.state.tabSeleccionado) {
    case 0:
      return (
        <ErrorUIComponent>
          <Proformas style={{background:'red'}}
            fdvID={id}
            fdv={that.props.fichasVenta.fichaVentaResponse[0]}
            fdvState={that.props.fichasVenta.fichaVentaResponse[0].codEstadoFichaVtaVeh}
            fetchProformas={that.props.fetchProformas}
            proformas={that.props.proformas.proformaExistenteList}
            proformaSeleccionada={that.state.proformaSeleccionada}
            selectProforma={that.selectProforma}
            pedidos={that.state.pedidosXfichaVenta}
            pedidosXfichaVenta={that.state.pedidosXfichaVenta}
            activeFilterPedido={that.state.activeFilterPedido}
            changeIndex={that.changeIndex}
            showRow={that.showRow}
            pedidoAcordeon={that.state.pedidoAcordeon}
            openModal={that.openModal}
            openAlert={that.openAlert}
            showDetallePedido={that.showDetallePedido}
            addPedidosAsignarBonos = {that.addPedidosAsignarBonos}
            arrayAsignarBonos={that.state.arrayAsignarBonos}
            //selectCheckPedidos={that.selectCheckPedidos}
            pedidosConCheck={that.state.pedidosConCheck}
            loading={that.loading}
            search={that.state.search}
            clientInput={that.state.clientInput}
            onChangeInput={that.onChangeInput}
            tipoAdicional={that.state.tipoAdicional}
            handlePageClickEquiposEspeciales={that.handlePageClickEquiposEspeciales}
            searchProveedorEquiposAdicionales={that.searchProveedorEquiposAdicionales}
            proveedorEquipoLogistica={that.state.proveedorEquipoLogistica}
            //fnCantidadPrecioEquipo={that.fnCantidadPrecioEquipo}
            proveedorEquposAdicionales={that.props.proveedorEquposAdicionales}
            nurPedidos={that.state.facturacionListado}
            idsProformas={that.state.idsProformas}
            fnListadoPedidosFacturacion={that.fnListadoPedidosFacturacion}
            loadProformas={that.loadProformas}
            traerFacturacion={that.fnListadoPedidosFacturacion}
            validarAsignacion={that.state.facturacionListado}
            loadPage = {that.loadPage}
            pedidosXfichaVentaChange = {that.pedidosXfichaVentaChange}
            handlePermissions={that.handlePermissions}
            handlePermissionsMassive={that.handlePermissionsMassive}
            doneAsignacionDefinitiva={that.doneAsignacionDefinitiva}
            isFinishedAsignacionDefinitiva={that.state.isFinishedAsignacionDefinitiva}
            listaCorreos={that.state.listaCorreos}//Req 92528 ebarboza 30 08 2021
          />
        </ErrorUIComponent>
        );
    case 1:
      return (
      <ErrorUIComponent>
        <Historial
          fetchHistorialFDV={that.props.fetchHistorialFDV}
          fetchTipoActividad={that.props.fetchTipoActividad}
          eventoPadre={`${parseInt(id, 10)}`}
          eventos={that.props.historial}
          fdvID={id}
          fdvState={that.props.fichasVenta.fichaVentaResponse[0].codEstadoFichaVtaVeh}
          openAlert={that.openAlert}
          loading={that.loading}
          handlePermissions={that.handlePermissions}
        />
      </ErrorUIComponent>
      );
    case 2:
      return (
        <ErrorUIComponent>
        <Adjuntos
          fdvID={id}
          handlePermissions={that.handlePermissions}
        />
        </ErrorUIComponent>
      );
    case 3:
      return (
        <ErrorUIComponent>
          <Excepciones
            excepciones={that.props.autorizacionesExcepcionales.listadoSolicitudes}
            seguimientoAutorizaciones={that.state.seguimientoAutorizaciones}
            openModal={that.openModal}
            fdvID={id}
            openAlert={that.openAlert}
            saveAutorizacionesExcepcionales={that.props.saveAutorizacionesExcepcionales}
            fetchAutorizacionesExcepcionales={that.props.fetchAutorizacionesExcepcionales}
            handlePermissions={that.handlePermissions}
          />
        </ErrorUIComponent>
      );
      case 4:
    return (
      <ErrorUIComponent>
            <Facturacion
              openModal={that.openModal}
              fdvID={id}
              openAlert={that.openAlert}
              handlePermissions={that.handlePermissions}
            />
      </ErrorUIComponent>
      );
  case 5:
    return (
      <ErrorUIComponent>

      <EquiposLogistica
        fdvID={id}
        /*Inicio Req 92293 ebarboza 09 08 2021 */
        codTipoMonedaProforma = {that.props.proformas.proformaExistenteList[0].tipoMoneda}
        /*Fin Req 92293 ebarboza 09 08 2021 */
        openEquipoAdicionales={that.openEquipoAdicionales}
        loading={that.loading}
        fichasVenta={that.props.fichasVenta}
        openAlert={that.openAlert}
        equiposCortesia={that.state.equiposCortesia}
        handlePermissions={that.handlePermissions}
      />
      </ErrorUIComponent>

    );
    case 6:
      return (
        <ErrorUIComponent>
        <Bonos
          openModal={that.openModal}
          pedidos={that.state.pedidosXfichaVenta}
          addPedidosAsignarBonos = {that.addPedidosAsignarBonos}
          arrayAsignarBonos={that.state.arrayAsignarBonos}
          fdvID={id}
          proformas={that.props.proformas.proformaExistenteList}
          proformaSeleccionada={that.state.proformaSeleccionada}
          selectProforma={that.selectProforma}
          handlePermissions={that.handlePermissions}
        />
        </ErrorUIComponent>
        );
    case 7:
      return (
        <ErrorUIComponent>
          <Observaciones
            fdvID={id}
            proformas={that.props.proformas.proformaExistenteList}
            fdv={that.props.fichasVenta.fichaVentaResponse}
            fetchProformas={that.props.fetchProformas}
            fetchFichaVenta={that.props.fetchFichaVenta}
            handlePermissions={that.handlePermissions}
          />
      </ErrorUIComponent>
      );
    case 8:
      return (
        <ErrorUIComponent>
          <AccesosDirecto
            fdvID={id}
            /*Inicio Req 92293 ebarboza 09 08 2021 */
            codTipoMonedaProforma = {that.props.proformas.proformaExistenteList[0].tipoMoneda}
            /*Fin Req 92293 ebarboza 09 08 2021 */
            handlePermissions={that.handlePermissions}
          />
        </ErrorUIComponent>
      );
    default:
      return null;
  }
}

export default renderTabcontainer;



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/TabViews/index.js